import React from 'react';
import ActivityLocation from './ActivityLocation';
import styles from './UserPreferenceEditForm.module.scss';
import AppButton from './AppButton';
import _ from 'lodash';
import { useHistory } from 'react-router';

export default function UserPreferenceEditForm(props) {    
    const history = useHistory();
    return (
        <form onSubmit={null}>
            <div>
                <div className="header">My Contact Details</div>
                <fieldset>
                    <div className="form-group">
                        <label>Name</label>
                        <input type="text" className="form-control" value={props.preferences.address.Contact.Name} 
                            onChange={e => props.onChange({address: {...props.preferences.address, Contact: {...props.preferences.address.Contact, Name: e.target.value}}})} />
                    </div>
                    <div className="form-group">
                        <label>Phone</label>
                        <input type="text" className="form-control" value={props.preferences.address.Contact.Phone} 
                            onChange={e => props.onChange({address: {...props.preferences.address, Contact: {...props.preferences.address.Contact, Phone: e.target.value}}})} />
                    </div>
                    <div className="form-group">
                        <label>Mobile</label>
                        <input type="text" className="form-control" value={props.preferences.address.Contact.Mobile} 
                            onChange={e => props.onChange({address: {...props.preferences.address, Contact: {...props.preferences.address.Contact, Mobile: e.target.value}}})} />
                    </div>
                    <div className="form-group">
                        <label>Email address</label>
                        <input type="email" readOnly className="form-control" value={props.preferences.address.Contact.Email} />
                    </div>
                </fieldset>
            </div>
            <div>
                <div style={{marginTop: "0.4em"}} />
                <ActivityLocation activityLocation={props.preferences.address} onActivityLocationChanged={e=>props.onChange({address: {...props.preferences.address, ...e}})} />
            </div>
            <div>
                <div style={{marginTop: "0.4em"}} />
                <div className="header">Terms</div>
                <div className="form-group form-check-inline">
                    <input type="checkbox" readOnly className="large" id="tAndC" checked={true} />
                    <label className="form-check-label">Acceptance of&nbsp;
                        <a target="_blank" href={props.config.termsAndConditions.generalUrl}>General</a> and&nbsp;
                        <a target="_blank" href={props.config.termsAndConditions.userAndPrivacyUrl}>User+Privacy</a> Terms &amp; Conditions
                    </label>
                </div>
            </div>
            <div className="action-area">
                <AppButton ajaxInProgress={props.busy} iconName="icon-function-save-down" actionText="Save" footer="Save my preferences" onClick={props.handleSubmit} />
                <AppButton function iconName="icon-function-left-arrow-up" actionText="Back" onClick={() => { history.push('../shipments')  }} footer="Return to my jobs"/>
            </div>
        </form>
        );
}
